import { render, staticRenderFns } from "./PointBalanceIndex.vue?vue&type=template&id=29513628&scoped=true"
import script from "./PointBalanceIndex.vue?vue&type=script&lang=js"
export * from "./PointBalanceIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29513628",
  null
  
)

export default component.exports